import { Injectable } from '@angular/core'
import { Session } from './Session'
import { HttpHeaders } from '@angular/common/http'

@Injectable({
    providedIn: 'root',
})
export class HttpClientOptionsService {
    constructor(private session: Session) {}

    public getPartnerhubAuthorization() {
        let loggedUser = this.session.get()

        let headers = {
            Authorization: `Bearer ${loggedUser?.account_user_session_token}`,
        }

        return {
            headers,
        }
    }

    customHeadersAuthorization(type: string, auth: string) {
        let authorization = ''
        if (type === 'bearer') authorization += `Bearer ${auth}`
        if (type === 'simple') authorization += auth

        let headers = new HttpHeaders({
            Authorization: authorization,
        })
        return headers
    }

    getPartnerhubAuthorizationAndParams(queryParams: any) {
        let loggedUser = this.session.get()

        let headers = {
            Authorization: `Bearer ${loggedUser?.account_user_session_token}`,
        }

        return { headers: headers, params: queryParams }
    }

    setBodyAndAuthorizationForDeleteRequest(body: object, auth: string, authType: string) {
        let authorization = ''
        if (authType === 'bearer') authorization += `Bearer ${auth}`
        if (authType === 'simple') authorization += auth

        let headers = new HttpHeaders({
            Authorization: authorization,
        })

        return { headers: headers, body: body }
    }
}
